import { render, staticRenderFns } from "./MenuContentSetting.vue?vue&type=template&id=7ed85dd8&scoped=true&"
var script = {}
import style0 from "./MenuContentSetting.vue?vue&type=style&index=0&id=7ed85dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed85dd8",
  null
  
)

export default component.exports